
import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Image from 'react-bootstrap/Image'
import './Gora.css';

export default function Gora() {
    return (
        <Container fluid  className="zxc">
            <Row>
                <Col className="gora1"><a target="_blank" href={process.env.REACT_APP_PS_MARKA_SITE }><Image className="logo"  src="https://test.polskiesklepy.pl/img/nlogo.jpg"/></a></Col>
                <Col className="gora1"><Logout /></Col>
            </Row>
        </Container>
    );
}
function getToken() {
    const tokenString = sessionStorage.getItem('token');
    const userToken = JSON.parse(tokenString);
    return userToken?.token
}

function flogout() {
    sessionStorage.removeItem('token');
    window.location=process.env.PUBLIC_URL+"/start";
}
function Logout() {
    const token = getToken();
    if (!token) {
        return (<></>);
    }
    return (
        <Button variant="outline-primary" type="submit" className="przycisk float-right" onClick={flogout}>
           <Image className="aaa" src="https://pics.freeicons.io/uploads/icons/png/853345161618134427-512.png"/> Wyloguj się 
        </Button>
    );

}
